import { render, staticRenderFns } from "./MyEvaluationsList.vue?vue&type=template&id=66242497"
import script from "./MyEvaluationsList.vue?vue&type=script&lang=js"
export * from "./MyEvaluationsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports